import { render, staticRenderFns } from "./BSC.vue?vue&type=template&id=6bc89d12&scoped=true&"
import script from "./BSC.vue?vue&type=script&lang=js&"
export * from "./BSC.vue?vue&type=script&lang=js&"
import style0 from "./BSC.vue?vue&type=style&index=0&id=6bc89d12&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc89d12",
  null
  
)

export default component.exports